import { uniq } from 'lodash';
import { useMemo } from 'react';
import { useParameter } from '../../../shared';

const MONTH_FREQUENCY = 4;

function createDate(calendarId: number) {
  if (calendarId) {
    const calendarString = String(calendarId);
    const year = Number(calendarString.slice(1, 5));
    const month = Number(calendarString.slice(5, 7));
    return new Date(year, month - 1);
  }
}
export function useSlideSubtitle() {
  const [calendarParameter] = useParameter<number[]>("@calendar");
  const subtitle = useMemo(() => {
    const monthes = calendarParameter?.filter(calendarId => {
      const frequency = Number(String(calendarId)[0]);
      return frequency === MONTH_FREQUENCY;
    }).sort() || [];

    const [firstMonthDate, lastMonthDate] = [0, monthes.length - 1].map(i => createDate(monthes[i]));

    const formatter = Intl.DateTimeFormat('en-US', {
      month: 'long',
      year: 'numeric'
    });

    const [firstFormateName, lastFormateName] = [firstMonthDate, lastMonthDate].map(date =>
      date ? formatter.format(date) : ''
    );
    return uniq([firstFormateName, lastFormateName]).join(' - ');
  }, [calendarParameter]);
  return subtitle;
}